class MediaStoryLightbox extends HTMLElement {
  connectedCallback() {
    this.dialog = this.querySelector('.msc-lightbox');
    this.viewport = this.querySelector('.msc-lightbox__viewport');
    this.captionEl = this.querySelector('.msc-lightbox__caption');
    this.muteBtn = this.querySelector('.msc-lightbox__mute');
    this.items = [...this.querySelectorAll('.msc-item')];
    this.index = 0;
    this.muted = true;

    if (!this.dialog || this.items.length === 0) return;

    this.items.forEach((item, i) => {
      item.addEventListener('click', () => this.open(i));
    });

    this.querySelector('.msc-lightbox__close')?.addEventListener('click', () => this.dialog.close());
    this.querySelector('.msc-lightbox__prev')?.addEventListener('click', () => this.show(this.index - 1));
    this.querySelector('.msc-lightbox__next')?.addEventListener('click', () => this.show(this.index + 1));
    this.muteBtn?.addEventListener('click', () => this.toggleMute());

    this.dialog.addEventListener('click', (event) => {
      if (event.target === this.dialog) this.dialog.close();
    });
    this.dialog.addEventListener('close', () => {
      this.viewport.innerHTML = '';
      this.unlockScroll();
    });
    this.dialog.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowRight') this.show(this.index + 1);
      if (event.key === 'ArrowLeft') this.show(this.index - 1);
    });
  }

  open(index) {
    this.show(index);
    if (typeof this.dialog.showModal === 'function') {
      this.dialog.showModal();
      this.lockScroll();
    }
  }

  lockScroll() {
    this._scrollY = window.scrollY;
    document.body.style.position = 'fixed';
    document.body.style.top = `-${this._scrollY}px`;
    document.body.style.left = '0';
    document.body.style.right = '0';
  }

  unlockScroll() {
    if (typeof this._scrollY !== 'number') return;
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    window.scrollTo(0, this._scrollY);
    this._scrollY = undefined;
  }

  show(index) {
    const count = this.items.length;
    this.index = (index + count) % count;
    const source = this.items[this.index].querySelector('.msc-item__media');
    if (!source) return;

    const clone = source.cloneNode(true);
    clone.removeAttribute('loading');
    this.viewport.innerHTML = '';
    this.viewport.appendChild(clone);

    const isVideo = clone.tagName === 'VIDEO';
    if (isVideo) {
      clone.muted = this.muted;
      clone.controls = false;
      clone.autoplay = true;
      clone.loop = true;
      clone.play().catch(() => {});
    }
    if (this.muteBtn) this.muteBtn.hidden = !isVideo;
    this.updateMuteIcon();

    const captionText = this.items[this.index].dataset.caption || '';
    if (this.captionEl) {
      this.captionEl.textContent = captionText;
      this.captionEl.hidden = !captionText;
    }
  }

  toggleMute() {
    const video = this.viewport.querySelector('video');
    if (!video) return;
    video.muted = !video.muted;
    this.muted = video.muted;
    this.updateMuteIcon();
  }

  updateMuteIcon() {
    if (!this.muteBtn) return;
    this.muteBtn.setAttribute('aria-pressed', String(!this.muted));
    this.muteBtn.classList.toggle('is-muted', this.muted);
  }
}

if (!customElements.get('media-story-lightbox')) {
  customElements.define('media-story-lightbox', MediaStoryLightbox);
}
